import React from "react";
import Autosizer from "react-virtualized-auto-sizer";
import { FixedSizeList } from "react-window";
import { makeStyles } from "tss-react/mui";
import { v4 } from "uuid";
import { MultiSelectItem } from "./MultiSelectItem.js";
import { doesInclude } from "./utils.js";
const useStyles = makeStyles()((theme, params) => ({
  virtualizedMultiSelectOptionListContainer: {
    height: theme.custom.menuItemHeight * params
  }
}));
function VirtualizedMultiSelectOptionList({
  chipType,
  ChipComponent,
  multiselectId,
  items,
  selectedValue,
  expandValue,
  visibleOptionCount = 6,
  suboptionsWithCheckbox = false,
  onItemClick,
  onExpand,
  onCollapse
}) {
  const { classes, theme } = useStyles(visibleOptionCount);
  const flatItems = items.map((i) => {
    const hasSuboptions = i.subOptions?.length > 0;
    const result = [];
    const isExpanded = doesInclude(expandValue, i.value.toString());
    if (hasSuboptions) {
      result.push({
        ...i,
        divider: !isExpanded,
        hasSuboptions: true
      });
      if (isExpanded) {
        i.subOptions.forEach(
          (j, index) => result.push({
            ...j,
            suboption: true,
            autoSelected: i.autoSelectOnExpand,
            divider: index === i.subOptions.length - 1
          })
        );
      }
    } else {
      result.push(i);
    }
    return result;
  }).flat();
  return /* @__PURE__ */ React.createElement("div", { className: classes.virtualizedMultiSelectOptionListContainer }, /* @__PURE__ */ React.createElement(Autosizer, null, ({ height, width }) => /* @__PURE__ */ React.createElement(
    FixedSizeList,
    {
      height,
      width,
      itemSize: theme.custom.menuItemHeight,
      itemCount: flatItems?.length
    },
    ({ index, style }) => {
      const item = flatItems[index];
      return /* @__PURE__ */ React.createElement(
        MultiSelectItem,
        {
          key: `multiselect-${multiselectId}-${item.value}-${v4()}`,
          value: item.value,
          chipValue: !item.autoSelected ? item.value : void 0,
          label: item.label,
          isSelected: doesInclude(selectedValue, item.value),
          chipType: !(item.autoSelected || item.hasSuboptions) ? chipType : void 0,
          ChipComponent,
          style,
          onClick: () => !item.autoSelected ? onItemClick(item.value) : () => {
          },
          checkbox: !item.autoSelected || suboptionsWithCheckbox,
          divider: item.divider,
          suboption: item.suboption,
          hasSuboptions: item.hasSuboptions,
          isExpanded: doesInclude(expandValue, item.value.toString()),
          onExpand: () => onExpand(item.value),
          onCollapse: () => onCollapse(item.value)
        }
      );
    }
  )));
}
export {
  VirtualizedMultiSelectOptionList
};
//# sourceMappingURL=VirtualizedMultiSelectOptionList.js.map
